import React from "react";

export default function EmptyState({ icon: Icon, title, subtitle, children, testId }) {
  return (
    <div data-testid={testId} className="flex flex-col items-center text-center px-6 py-14 animate-rise">
      {Icon && (
        <div className="h-16 w-16 rounded-2xl bg-secondary flex items-center justify-center mb-5">
          <Icon className="h-8 w-8 text-primary" strokeWidth={1.75} />
        </div>
      )}
      <h3 className="font-display text-xl font-bold text-foreground">{title}</h3>
      {subtitle && <p className="mt-2 text-sm text-muted-foreground max-w-xs leading-relaxed">{subtitle}</p>}
      {children && <div className="mt-6 w-full flex flex-col items-center gap-3">{children}</div>}
    </div>
  );
}
